import { jsxs as p, jsx as o } from "react/jsx-runtime";
import { memo as u } from "react";
import { Row as l, Col as n, Input as c } from "antd";
import { useLanguageResolver as f } from "@biron-data/react-contexts";
const R = u(
  function({
    value: e,
    placeholder: r,
    maxLength: t = 255,
    onChange: i,
    span: s = 14,
    ...m
  }) {
    const a = f();
    return /* @__PURE__ */ p(l, { children: [
      /* @__PURE__ */ o(n, { span: s, children: /* @__PURE__ */ o(c, { className: "biron-react-input", value: e, maxLength: t, placeholder: r ? a.get(r) : void 0, onChange: i, ...m }) }),
      /* @__PURE__ */ o(n, { span: 101 })
    ] });
  }
);
export {
  R as default
};
//# sourceMappingURL=BironInput.js.map
